module.exports = __webpack_public_path__ + "img/Jungle_Gym_Backyard_Playgrounds_1988_RGB_big.ccc3161e.png";